import { jsx } from "react/jsx-runtime";
function Svg({ children, ...props }) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      focusable: "false",
      ...props,
      children
    }
  );
}
function MenuIcon(props) {
  return /* @__PURE__ */ jsx(Svg, { ...props, children: /* @__PURE__ */ jsx("path", { d: "M4 7h16M4 12h16M4 17h16" }) });
}
function CloseIcon(props) {
  return /* @__PURE__ */ jsx(Svg, { ...props, children: /* @__PURE__ */ jsx("path", { d: "M6 6l12 12M18 6L6 18" }) });
}
function SwapIcon(props) {
  return /* @__PURE__ */ jsx(Svg, { ...props, children: /* @__PURE__ */ jsx("path", { d: "M7 4L3 8l4 4M3 8h14M17 20l4-4-4-4M21 16H7" }) });
}
function SignOutIcon(props) {
  return /* @__PURE__ */ jsx(Svg, { ...props, children: /* @__PURE__ */ jsx("path", { d: "M15 4h4v16h-4M10 8l-4 4 4 4M6 12h11" }) });
}
export {
  CloseIcon,
  MenuIcon,
  SignOutIcon,
  SwapIcon
};
//# sourceMappingURL=icons.js.map
